/**
 * SQLite schreibt CURRENT_TIMESTAMP als "YYYY-MM-DD HH:MM:SS" in UTC, aber ohne Zonenangabe.
 * `new Date()` liest solche Werte als Ortszeit, in Deutschland also ein bis zwei Stunden zu früh.
 * Zeitstempel ohne Zone werden deshalb hier ausdrücklich als UTC gelesen.
 */
const NAIVE_TIMESTAMP = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;

/** Millisekunden seit 1970 oder 0, wenn der Wert fehlt oder unlesbar ist. */
export const parseServerTimestamp = (value: string | null | undefined): number => {
  if (!value) return 0;
  const naive = NAIVE_TIMESTAMP.exec(value.trim());
  const ms = naive ? Date.parse(`${naive[1]}T${naive[2]}Z`) : Date.parse(value);
  return Number.isNaN(ms) ? 0 : ms;
};
